/* tslint:disable */
/* eslint-disable */
/**
 * AI Secretary
 * AI-powered voice assistant platform for automated appointment scheduling, customer communication, and CRM integration
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { HTTPValidationError } from '../models';
// @ts-ignore
import type { KnowledgeBaseBulkCreateDTO } from '../models';
// @ts-ignore
import type { KnowledgeBaseCreateDTO } from '../models';
// @ts-ignore
import type { KnowledgeBaseResponseDTO } from '../models';
// @ts-ignore
import type { KnowledgeBaseSearchResultDTO } from '../models';
// @ts-ignore
import type { KnowledgeBaseUpdateDTO } from '../models';
// @ts-ignore
import type { PDFAnalysisResponseDTO } from '../models';
// @ts-ignore
import type { PageKnowledgeBaseResponseDTO } from '../models';
// @ts-ignore
import type { PageWebsiteSourceResponseDTO } from '../models';
// @ts-ignore
import type { WebsiteSourceCreateDTO } from '../models';
// @ts-ignore
import type { WebsiteSourceDetailDTO } from '../models';
// @ts-ignore
import type { WebsiteSourceResponseDTO } from '../models';
/**
 * KnowledgeBaseApi - axios parameter creator
 * @export
 */
export const KnowledgeBaseApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Analyze a PDF file and return proposed topic-based knowledge-base entries. Requires \'knowledge:write\' permission.  This endpoint: 1. Validates the uploaded file (type and size) 2. Extracts text from the PDF page by page 3. Uses AI to split the document into logical topics, one proposed entry    per topic (a small or single-topic PDF simply yields one entry)  A scanned/image-only PDF with no extractable text is rejected with 400.  Maximum file size: 10MB (configurable via MAX_PDF_SIZE_MB)  Note: This is a utility endpoint and does not modify any database models.
         * @summary Analyze Pdf
         * @param {string} file 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        analyzePdfApiV1KnowledgeBaseAnalyzePdfPost: async (file: string, authorization?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'file' is not null or undefined
            assertParamExists('analyzePdfApiV1KnowledgeBaseAnalyzePdfPost', 'file', file)
            const localVarPath = `/api/v1/knowledge-base/analyze-pdf`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();


            if (file !== undefined) { 
                localVarFormParams.append('file', file as any);
            }
    
    
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
    
            if (authorization != null) {
                localVarHeaderParameter['authorization'] = String(authorization);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams;

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Analyze a PDF file and return proposed topic-based knowledge-base entries. Requires \'knowledge:write\' permission.  This endpoint: 1. Validates the uploaded file (type and size) 2. Extracts text from the PDF page by page 3. Uses AI to split the document into logical topics, one proposed entry    per topic (a small or single-topic PDF simply yields one entry)  A scanned/image-only PDF with no extractable text is rejected with 400.  Maximum file size: 10MB (configurable via MAX_PDF_SIZE_MB)  Note: This is a utility endpoint and does not modify any database models.
         * @summary Analyze Pdf
         * @param {string} file 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        analyzePdfApiV1KnowledgeBaseAnalyzePdfPost_1: async (file: string, authorization?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'file' is not null or undefined
            assertParamExists('analyzePdfApiV1KnowledgeBaseAnalyzePdfPost_1', 'file', file)
            const localVarPath = `/api/v1/knowledge-base/analyze-pdf`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();


            if (file !== undefined) { 
                localVarFormParams.append('file', file as any);
            }
    
    
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
    
            if (authorization != null) {
                localVarHeaderParameter['authorization'] = String(authorization);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams;

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Create multiple knowledge base entries in one request (all-or-nothing).  Rows and their embeddings are persisted together: any failure rolls the whole batch back, so no partial save is left for the caller to reconcile. Requires \'knowledge:write\' permission.
         * @summary Create Knowledge Entries Bulk
         * @param {KnowledgeBaseBulkCreateDTO} knowledgeBaseBulkCreateDTO 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createKnowledgeEntriesBulkApiV1KnowledgeBaseBulkPost: async (knowledgeBaseBulkCreateDTO: KnowledgeBaseBulkCreateDTO, authorization?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'knowledgeBaseBulkCreateDTO' is not null or undefined
            assertParamExists('createKnowledgeEntriesBulkApiV1KnowledgeBaseBulkPost', 'knowledgeBaseBulkCreateDTO', knowledgeBaseBulkCreateDTO)
            const localVarPath = `/api/v1/knowledge-base/bulk`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            if (authorization != null) {
                localVarHeaderParameter['authorization'] = String(authorization);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(knowledgeBaseBulkCreateDTO, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Create multiple knowledge base entries in one request (all-or-nothing).  Rows and their embeddings are persisted together: any failure rolls the whole batch back, so no partial save is left for the caller to reconcile. Requires \'knowledge:write\' permission.
         * @summary Create Knowledge Entries Bulk
         * @param {KnowledgeBaseBulkCreateDTO} knowledgeBaseBulkCreateDTO 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createKnowledgeEntriesBulkApiV1KnowledgeBaseBulkPost_2: async (knowledgeBaseBulkCreateDTO: KnowledgeBaseBulkCreateDTO, authorization?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'knowledgeBaseBulkCreateDTO' is not null or undefined
            assertParamExists('createKnowledgeEntriesBulkApiV1KnowledgeBaseBulkPost_2', 'knowledgeBaseBulkCreateDTO', knowledgeBaseBulkCreateDTO)
            const localVarPath = `/api/v1/knowledge-base/bulk`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            if (authorization != null) {
                localVarHeaderParameter['authorization'] = String(authorization);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(knowledgeBaseBulkCreateDTO, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Create a new knowledge base entry with vector embedding. Requires \'knowledge:write\' permission.
         * @summary Create Knowledge Entry
         * @param {KnowledgeBaseCreateDTO} knowledgeBaseCreateDTO 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createKnowledgeEntryApiV1KnowledgeBasePost: async (knowledgeBaseCreateDTO: KnowledgeBaseCreateDTO, authorization?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'knowledgeBaseCreateDTO' is not null or undefined
            assertParamExists('createKnowledgeEntryApiV1KnowledgeBasePost', 'knowledgeBaseCreateDTO', knowledgeBaseCreateDTO)
            const localVarPath = `/api/v1/knowledge-base/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            if (authorization != null) {
                localVarHeaderParameter['authorization'] = String(authorization);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(knowledgeBaseCreateDTO, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Create a new knowledge base entry with vector embedding. Requires \'knowledge:write\' permission.
         * @summary Create Knowledge Entry
         * @param {KnowledgeBaseCreateDTO} knowledgeBaseCreateDTO 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createKnowledgeEntryApiV1KnowledgeBasePost_3: async (knowledgeBaseCreateDTO: KnowledgeBaseCreateDTO, authorization?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'knowledgeBaseCreateDTO' is not null or undefined
            assertParamExists('createKnowledgeEntryApiV1KnowledgeBasePost_3', 'knowledgeBaseCreateDTO', knowledgeBaseCreateDTO)
            const localVarPath = `/api/v1/knowledge-base/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            if (authorization != null) {
                localVarHeaderParameter['authorization'] = String(authorization);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(knowledgeBaseCreateDTO, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Register a website as a knowledge-base source and start its first crawl. Requires \'knowledge:write\' permission.
         * @summary Create Website Source
         * @param {WebsiteSourceCreateDTO} websiteSourceCreateDTO 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createWebsiteSourceApiV1KnowledgeBaseWebsitePost: async (websiteSourceCreateDTO: WebsiteSourceCreateDTO, authorization?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'websiteSourceCreateDTO' is not null or undefined
            assertParamExists('createWebsiteSourceApiV1KnowledgeBaseWebsitePost', 'websiteSourceCreateDTO', websiteSourceCreateDTO)
            const localVarPath = `/api/v1/knowledge-base/website`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            if (authorization != null) {
                localVarHeaderParameter['authorization'] = String(authorization);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(websiteSourceCreateDTO, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Register a website as a knowledge-base source and start its first crawl. Requires \'knowledge:write\' permission.
         * @summary Create Website Source
         * @param {WebsiteSourceCreateDTO} websiteSourceCreateDTO 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createWebsiteSourceApiV1KnowledgeBaseWebsitePost_4: async (websiteSourceCreateDTO: WebsiteSourceCreateDTO, authorization?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'websiteSourceCreateDTO' is not null or undefined
            assertParamExists('createWebsiteSourceApiV1KnowledgeBaseWebsitePost_4', 'websiteSourceCreateDTO', websiteSourceCreateDTO)
            const localVarPath = `/api/v1/knowledge-base/website`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            if (authorization != null) {
                localVarHeaderParameter['authorization'] = String(authorization);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(websiteSourceCreateDTO, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Soft delete a knowledge base entry. Requires \'knowledge:write\' permission.
         * @summary Delete Knowledge Entry
         * @param {string} entryId 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteKnowledgeEntryApiV1KnowledgeBaseEntryIdDelete: async (entryId: string, authorization?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'entryId' is not null or undefined
            assertParamExists('deleteKnowledgeEntryApiV1KnowledgeBaseEntryIdDelete', 'entryId', entryId)
            const localVarPath = `/api/v1/knowledge-base/{entry_id}`
                .replace(`{${"entry_id"}}`, encodeURIComponent(String(entryId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            if (authorization != null) {
                localVarHeaderParameter['authorization'] = String(authorization);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Soft delete a knowledge base entry. Requires \'knowledge:write\' permission.
         * @summary Delete Knowledge Entry
         * @param {string} entryId 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteKnowledgeEntryApiV1KnowledgeBaseEntryIdDelete_5: async (entryId: string, authorization?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'entryId' is not null or undefined
            assertParamExists('deleteKnowledgeEntryApiV1KnowledgeBaseEntryIdDelete_5', 'entryId', entryId)
            const localVarPath = `/api/v1/knowledge-base/{entry_id}`
                .replace(`{${"entry_id"}}`, encodeURIComponent(String(entryId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            if (authorization != null) {
                localVarHeaderParameter['authorization'] = String(authorization);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Delete a website source and its generated child entries. Requires \'knowledge:write\' permission.
         * @summary Delete Website Source
         * @param {string} sourceId 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteWebsiteSourceApiV1KnowledgeBaseWebsiteSourceIdDelete: async (sourceId: string, authorization?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'sourceId' is not null or undefined
            assertParamExists('deleteWebsiteSourceApiV1KnowledgeBaseWebsiteSourceIdDelete', 'sourceId', sourceId)
            const localVarPath = `/api/v1/knowledge-base/website/{source_id}`
                .replace(`{${"source_id"}}`, encodeURIComponent(String(sourceId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            if (authorization != null) {
                localVarHeaderParameter['authorization'] = String(authorization);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Delete a website source and its generated child entries. Requires \'knowledge:write\' permission.
         * @summary Delete Website Source
         * @param {string} sourceId 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteWebsiteSourceApiV1KnowledgeBaseWebsiteSourceIdDelete_6: async (sourceId: string, authorization?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'sourceId' is not null or undefined
            assertParamExists('deleteWebsiteSourceApiV1KnowledgeBaseWebsiteSourceIdDelete_6', 'sourceId', sourceId)
            const localVarPath = `/api/v1/knowledge-base/website/{source_id}`
                .replace(`{${"source_id"}}`, encodeURIComponent(String(sourceId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            if (authorization != null) {
                localVarHeaderParameter['authorization'] = String(authorization);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get a specific knowledge base entry by ID. Requires \'knowledge:view\' permission.
         * @summary Get Knowledge Entry
         * @param {string} entryId 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getKnowledgeEntryApiV1KnowledgeBaseEntryIdGet: async (entryId: string, authorization?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'entryId' is not null or undefined
            assertParamExists('getKnowledgeEntryApiV1KnowledgeBaseEntryIdGet', 'entryId', entryId)
            const localVarPath = `/api/v1/knowledge-base/{entry_id}`
                .replace(`{${"entry_id"}}`, encodeURIComponent(String(entryId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            if (authorization != null) {
                localVarHeaderParameter['authorization'] = String(authorization);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get a specific knowledge base entry by ID. Requires \'knowledge:view\' permission.
         * @summary Get Knowledge Entry
         * @param {string} entryId 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getKnowledgeEntryApiV1KnowledgeBaseEntryIdGet_7: async (entryId: string, authorization?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'entryId' is not null or undefined
            assertParamExists('getKnowledgeEntryApiV1KnowledgeBaseEntryIdGet_7', 'entryId', entryId)
            const localVarPath = `/api/v1/knowledge-base/{entry_id}`
                .replace(`{${"entry_id"}}`, encodeURIComponent(String(entryId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            if (authorization != null) {
                localVarHeaderParameter['authorization'] = String(authorization);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get a website source with its read-only child entries. Requires \'knowledge:write\' permission.
         * @summary Get Website Source
         * @param {string} sourceId 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getWebsiteSourceApiV1KnowledgeBaseWebsiteSourceIdGet: async (sourceId: string, authorization?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'sourceId' is not null or undefined
            assertParamExists('getWebsiteSourceApiV1KnowledgeBaseWebsiteSourceIdGet', 'sourceId', sourceId)
            const localVarPath = `/api/v1/knowledge-base/website/{source_id}`
                .replace(`{${"source_id"}}`, encodeURIComponent(String(sourceId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            if (authorization != null) {
                localVarHeaderParameter['authorization'] = String(authorization);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get a website source with its read-only child entries. Requires \'knowledge:write\' permission.
         * @summary Get Website Source
         * @param {string} sourceId 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getWebsiteSourceApiV1KnowledgeBaseWebsiteSourceIdGet_8: async (sourceId: string, authorization?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'sourceId' is not null or undefined
            assertParamExists('getWebsiteSourceApiV1KnowledgeBaseWebsiteSourceIdGet_8', 'sourceId', sourceId)
            const localVarPath = `/api/v1/knowledge-base/website/{source_id}`
                .replace(`{${"source_id"}}`, encodeURIComponent(String(sourceId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            if (authorization != null) {
                localVarHeaderParameter['authorization'] = String(authorization);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * List all active knowledge base entries in the current user\'s organization. Requires \'knowledge:view\' permission.
         * @summary List Knowledge Entries
         * @param {number} [limit] 
         * @param {number} [offset] 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listKnowledgeEntriesApiV1KnowledgeBaseGet: async (limit?: number, offset?: number, authorization?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/knowledge-base/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }


    
            if (authorization != null) {
                localVarHeaderParameter['authorization'] = String(authorization);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * List all active knowledge base entries in the current user\'s organization. Requires \'knowledge:view\' permission.
         * @summary List Knowledge Entries
         * @param {number} [limit] 
         * @param {number} [offset] 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listKnowledgeEntriesApiV1KnowledgeBaseGet_9: async (limit?: number, offset?: number, authorization?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/knowledge-base/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }


    
            if (authorization != null) {
                localVarHeaderParameter['authorization'] = String(authorization);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * List the organization\'s website sources with sync status and entry counts. Requires \'knowledge:write\' permission.
         * @summary List Website Sources
         * @param {number} [limit] 
         * @param {number} [offset] 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listWebsiteSourcesApiV1KnowledgeBaseWebsiteGet: async (limit?: number, offset?: number, authorization?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/knowledge-base/website`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }


    
            if (authorization != null) {
                localVarHeaderParameter['authorization'] = String(authorization);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * List the organization\'s website sources with sync status and entry counts. Requires \'knowledge:write\' permission.
         * @summary List Website Sources
         * @param {number} [limit] 
         * @param {number} [offset] 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listWebsiteSourcesApiV1KnowledgeBaseWebsiteGet_10: async (limit?: number, offset?: number, authorization?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/knowledge-base/website`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }


    
            if (authorization != null) {
                localVarHeaderParameter['authorization'] = String(authorization);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Re-crawl a website source. Only allowed when it is idle (READY/FAILED). Requires \'knowledge:write\' permission.
         * @summary Resync Website Source
         * @param {string} sourceId 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        resyncWebsiteSourceApiV1KnowledgeBaseWebsiteSourceIdResyncPost: async (sourceId: string, authorization?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'sourceId' is not null or undefined
            assertParamExists('resyncWebsiteSourceApiV1KnowledgeBaseWebsiteSourceIdResyncPost', 'sourceId', sourceId)
            const localVarPath = `/api/v1/knowledge-base/website/{source_id}/resync`
                .replace(`{${"source_id"}}`, encodeURIComponent(String(sourceId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            if (authorization != null) {
                localVarHeaderParameter['authorization'] = String(authorization);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Re-crawl a website source. Only allowed when it is idle (READY/FAILED). Requires \'knowledge:write\' permission.
         * @summary Resync Website Source
         * @param {string} sourceId 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        resyncWebsiteSourceApiV1KnowledgeBaseWebsiteSourceIdResyncPost_11: async (sourceId: string, authorization?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'sourceId' is not null or undefined
            assertParamExists('resyncWebsiteSourceApiV1KnowledgeBaseWebsiteSourceIdResyncPost_11', 'sourceId', sourceId)
            const localVarPath = `/api/v1/knowledge-base/website/{source_id}/resync`
                .replace(`{${"source_id"}}`, encodeURIComponent(String(sourceId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            if (authorization != null) {
                localVarHeaderParameter['authorization'] = String(authorization);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Search knowledge base entries by name pattern. Requires \'knowledge:view\' permission.
         * @summary Search By Name
         * @param {string} name 
         * @param {number} [limit] 
         * @param {number} [offset] 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchByNameApiV1KnowledgeBaseSearchNameGet: async (name: string, limit?: number, offset?: number, authorization?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'name' is not null or undefined
            assertParamExists('searchByNameApiV1KnowledgeBaseSearchNameGet', 'name', name)
            const localVarPath = `/api/v1/knowledge-base/search/name`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (name !== undefined) {
                localVarQueryParameter['name'] = name;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }


    
            if (authorization != null) {
                localVarHeaderParameter['authorization'] = String(authorization);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Search knowledge base entries by name pattern. Requires \'knowledge:view\' permission.
         * @summary Search By Name
         * @param {string} name 
         * @param {number} [limit] 
         * @param {number} [offset] 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchByNameApiV1KnowledgeBaseSearchNameGet_12: async (name: string, limit?: number, offset?: number, authorization?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'name' is not null or undefined
            assertParamExists('searchByNameApiV1KnowledgeBaseSearchNameGet_12', 'name', name)
            const localVarPath = `/api/v1/knowledge-base/search/name`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (name !== undefined) {
                localVarQueryParameter['name'] = name;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }


    
            if (authorization != null) {
                localVarHeaderParameter['authorization'] = String(authorization);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Search knowledge base using semantic similarity. Requires \'knowledge:view\' permission.  Returns entries ranked by relevance to the query.
         * @summary Search By Similarity
         * @param {string} query 
         * @param {number} [limit] 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchBySimilarityApiV1KnowledgeBaseSearchPost: async (query: string, limit?: number, authorization?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'query' is not null or undefined
            assertParamExists('searchBySimilarityApiV1KnowledgeBaseSearchPost', 'query', query)
            const localVarPath = `/api/v1/knowledge-base/search`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (query !== undefined) {
                localVarQueryParameter['query'] = query;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }


    
            if (authorization != null) {
                localVarHeaderParameter['authorization'] = String(authorization);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Search knowledge base using semantic similarity. Requires \'knowledge:view\' permission.  Returns entries ranked by relevance to the query.
         * @summary Search By Similarity
         * @param {string} query 
         * @param {number} [limit] 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchBySimilarityApiV1KnowledgeBaseSearchPost_13: async (query: string, limit?: number, authorization?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'query' is not null or undefined
            assertParamExists('searchBySimilarityApiV1KnowledgeBaseSearchPost_13', 'query', query)
            const localVarPath = `/api/v1/knowledge-base/search`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (query !== undefined) {
                localVarQueryParameter['query'] = query;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }


    
            if (authorization != null) {
                localVarHeaderParameter['authorization'] = String(authorization);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Update a knowledge base entry. Re-generates embedding if content changed. Requires \'knowledge:write\' permission.
         * @summary Update Knowledge Entry
         * @param {string} entryId 
         * @param {KnowledgeBaseUpdateDTO} knowledgeBaseUpdateDTO 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateKnowledgeEntryApiV1KnowledgeBaseEntryIdPatch: async (entryId: string, knowledgeBaseUpdateDTO: KnowledgeBaseUpdateDTO, authorization?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'entryId' is not null or undefined
            assertParamExists('updateKnowledgeEntryApiV1KnowledgeBaseEntryIdPatch', 'entryId', entryId)
            // verify required parameter 'knowledgeBaseUpdateDTO' is not null or undefined
            assertParamExists('updateKnowledgeEntryApiV1KnowledgeBaseEntryIdPatch', 'knowledgeBaseUpdateDTO', knowledgeBaseUpdateDTO)
            const localVarPath = `/api/v1/knowledge-base/{entry_id}`
                .replace(`{${"entry_id"}}`, encodeURIComponent(String(entryId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            if (authorization != null) {
                localVarHeaderParameter['authorization'] = String(authorization);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(knowledgeBaseUpdateDTO, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Update a knowledge base entry. Re-generates embedding if content changed. Requires \'knowledge:write\' permission.
         * @summary Update Knowledge Entry
         * @param {string} entryId 
         * @param {KnowledgeBaseUpdateDTO} knowledgeBaseUpdateDTO 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateKnowledgeEntryApiV1KnowledgeBaseEntryIdPatch_14: async (entryId: string, knowledgeBaseUpdateDTO: KnowledgeBaseUpdateDTO, authorization?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'entryId' is not null or undefined
            assertParamExists('updateKnowledgeEntryApiV1KnowledgeBaseEntryIdPatch_14', 'entryId', entryId)
            // verify required parameter 'knowledgeBaseUpdateDTO' is not null or undefined
            assertParamExists('updateKnowledgeEntryApiV1KnowledgeBaseEntryIdPatch_14', 'knowledgeBaseUpdateDTO', knowledgeBaseUpdateDTO)
            const localVarPath = `/api/v1/knowledge-base/{entry_id}`
                .replace(`{${"entry_id"}}`, encodeURIComponent(String(entryId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            if (authorization != null) {
                localVarHeaderParameter['authorization'] = String(authorization);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(knowledgeBaseUpdateDTO, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * KnowledgeBaseApi - functional programming interface
 * @export
 */
export const KnowledgeBaseApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = KnowledgeBaseApiAxiosParamCreator(configuration)
    return {
        /**
         * Analyze a PDF file and return proposed topic-based knowledge-base entries. Requires \'knowledge:write\' permission.  This endpoint: 1. Validates the uploaded file (type and size) 2. Extracts text from the PDF page by page 3. Uses AI to split the document into logical topics, one proposed entry    per topic (a small or single-topic PDF simply yields one entry)  A scanned/image-only PDF with no extractable text is rejected with 400.  Maximum file size: 10MB (configurable via MAX_PDF_SIZE_MB)  Note: This is a utility endpoint and does not modify any database models.
         * @summary Analyze Pdf
         * @param {string} file 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async analyzePdfApiV1KnowledgeBaseAnalyzePdfPost(file: string, authorization?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PDFAnalysisResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.analyzePdfApiV1KnowledgeBaseAnalyzePdfPost(file, authorization, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['KnowledgeBaseApi.analyzePdfApiV1KnowledgeBaseAnalyzePdfPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Analyze a PDF file and return proposed topic-based knowledge-base entries. Requires \'knowledge:write\' permission.  This endpoint: 1. Validates the uploaded file (type and size) 2. Extracts text from the PDF page by page 3. Uses AI to split the document into logical topics, one proposed entry    per topic (a small or single-topic PDF simply yields one entry)  A scanned/image-only PDF with no extractable text is rejected with 400.  Maximum file size: 10MB (configurable via MAX_PDF_SIZE_MB)  Note: This is a utility endpoint and does not modify any database models.
         * @summary Analyze Pdf
         * @param {string} file 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async analyzePdfApiV1KnowledgeBaseAnalyzePdfPost_1(file: string, authorization?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PDFAnalysisResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.analyzePdfApiV1KnowledgeBaseAnalyzePdfPost_1(file, authorization, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['KnowledgeBaseApi.analyzePdfApiV1KnowledgeBaseAnalyzePdfPost_1']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Create multiple knowledge base entries in one request (all-or-nothing).  Rows and their embeddings are persisted together: any failure rolls the whole batch back, so no partial save is left for the caller to reconcile. Requires \'knowledge:write\' permission.
         * @summary Create Knowledge Entries Bulk
         * @param {KnowledgeBaseBulkCreateDTO} knowledgeBaseBulkCreateDTO 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createKnowledgeEntriesBulkApiV1KnowledgeBaseBulkPost(knowledgeBaseBulkCreateDTO: KnowledgeBaseBulkCreateDTO, authorization?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<KnowledgeBaseResponseDTO>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createKnowledgeEntriesBulkApiV1KnowledgeBaseBulkPost(knowledgeBaseBulkCreateDTO, authorization, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['KnowledgeBaseApi.createKnowledgeEntriesBulkApiV1KnowledgeBaseBulkPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Create multiple knowledge base entries in one request (all-or-nothing).  Rows and their embeddings are persisted together: any failure rolls the whole batch back, so no partial save is left for the caller to reconcile. Requires \'knowledge:write\' permission.
         * @summary Create Knowledge Entries Bulk
         * @param {KnowledgeBaseBulkCreateDTO} knowledgeBaseBulkCreateDTO 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createKnowledgeEntriesBulkApiV1KnowledgeBaseBulkPost_2(knowledgeBaseBulkCreateDTO: KnowledgeBaseBulkCreateDTO, authorization?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<KnowledgeBaseResponseDTO>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createKnowledgeEntriesBulkApiV1KnowledgeBaseBulkPost_2(knowledgeBaseBulkCreateDTO, authorization, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['KnowledgeBaseApi.createKnowledgeEntriesBulkApiV1KnowledgeBaseBulkPost_2']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Create a new knowledge base entry with vector embedding. Requires \'knowledge:write\' permission.
         * @summary Create Knowledge Entry
         * @param {KnowledgeBaseCreateDTO} knowledgeBaseCreateDTO 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createKnowledgeEntryApiV1KnowledgeBasePost(knowledgeBaseCreateDTO: KnowledgeBaseCreateDTO, authorization?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<KnowledgeBaseResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createKnowledgeEntryApiV1KnowledgeBasePost(knowledgeBaseCreateDTO, authorization, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['KnowledgeBaseApi.createKnowledgeEntryApiV1KnowledgeBasePost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Create a new knowledge base entry with vector embedding. Requires \'knowledge:write\' permission.
         * @summary Create Knowledge Entry
         * @param {KnowledgeBaseCreateDTO} knowledgeBaseCreateDTO 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createKnowledgeEntryApiV1KnowledgeBasePost_3(knowledgeBaseCreateDTO: KnowledgeBaseCreateDTO, authorization?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<KnowledgeBaseResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createKnowledgeEntryApiV1KnowledgeBasePost_3(knowledgeBaseCreateDTO, authorization, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['KnowledgeBaseApi.createKnowledgeEntryApiV1KnowledgeBasePost_3']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Register a website as a knowledge-base source and start its first crawl. Requires \'knowledge:write\' permission.
         * @summary Create Website Source
         * @param {WebsiteSourceCreateDTO} websiteSourceCreateDTO 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createWebsiteSourceApiV1KnowledgeBaseWebsitePost(websiteSourceCreateDTO: WebsiteSourceCreateDTO, authorization?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<WebsiteSourceResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createWebsiteSourceApiV1KnowledgeBaseWebsitePost(websiteSourceCreateDTO, authorization, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['KnowledgeBaseApi.createWebsiteSourceApiV1KnowledgeBaseWebsitePost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Register a website as a knowledge-base source and start its first crawl. Requires \'knowledge:write\' permission.
         * @summary Create Website Source
         * @param {WebsiteSourceCreateDTO} websiteSourceCreateDTO 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createWebsiteSourceApiV1KnowledgeBaseWebsitePost_4(websiteSourceCreateDTO: WebsiteSourceCreateDTO, authorization?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<WebsiteSourceResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createWebsiteSourceApiV1KnowledgeBaseWebsitePost_4(websiteSourceCreateDTO, authorization, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['KnowledgeBaseApi.createWebsiteSourceApiV1KnowledgeBaseWebsitePost_4']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Soft delete a knowledge base entry. Requires \'knowledge:write\' permission.
         * @summary Delete Knowledge Entry
         * @param {string} entryId 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteKnowledgeEntryApiV1KnowledgeBaseEntryIdDelete(entryId: string, authorization?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteKnowledgeEntryApiV1KnowledgeBaseEntryIdDelete(entryId, authorization, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['KnowledgeBaseApi.deleteKnowledgeEntryApiV1KnowledgeBaseEntryIdDelete']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Soft delete a knowledge base entry. Requires \'knowledge:write\' permission.
         * @summary Delete Knowledge Entry
         * @param {string} entryId 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteKnowledgeEntryApiV1KnowledgeBaseEntryIdDelete_5(entryId: string, authorization?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteKnowledgeEntryApiV1KnowledgeBaseEntryIdDelete_5(entryId, authorization, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['KnowledgeBaseApi.deleteKnowledgeEntryApiV1KnowledgeBaseEntryIdDelete_5']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Delete a website source and its generated child entries. Requires \'knowledge:write\' permission.
         * @summary Delete Website Source
         * @param {string} sourceId 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteWebsiteSourceApiV1KnowledgeBaseWebsiteSourceIdDelete(sourceId: string, authorization?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteWebsiteSourceApiV1KnowledgeBaseWebsiteSourceIdDelete(sourceId, authorization, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['KnowledgeBaseApi.deleteWebsiteSourceApiV1KnowledgeBaseWebsiteSourceIdDelete']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Delete a website source and its generated child entries. Requires \'knowledge:write\' permission.
         * @summary Delete Website Source
         * @param {string} sourceId 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteWebsiteSourceApiV1KnowledgeBaseWebsiteSourceIdDelete_6(sourceId: string, authorization?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteWebsiteSourceApiV1KnowledgeBaseWebsiteSourceIdDelete_6(sourceId, authorization, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['KnowledgeBaseApi.deleteWebsiteSourceApiV1KnowledgeBaseWebsiteSourceIdDelete_6']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get a specific knowledge base entry by ID. Requires \'knowledge:view\' permission.
         * @summary Get Knowledge Entry
         * @param {string} entryId 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getKnowledgeEntryApiV1KnowledgeBaseEntryIdGet(entryId: string, authorization?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<KnowledgeBaseResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getKnowledgeEntryApiV1KnowledgeBaseEntryIdGet(entryId, authorization, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['KnowledgeBaseApi.getKnowledgeEntryApiV1KnowledgeBaseEntryIdGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get a specific knowledge base entry by ID. Requires \'knowledge:view\' permission.
         * @summary Get Knowledge Entry
         * @param {string} entryId 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getKnowledgeEntryApiV1KnowledgeBaseEntryIdGet_7(entryId: string, authorization?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<KnowledgeBaseResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getKnowledgeEntryApiV1KnowledgeBaseEntryIdGet_7(entryId, authorization, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['KnowledgeBaseApi.getKnowledgeEntryApiV1KnowledgeBaseEntryIdGet_7']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get a website source with its read-only child entries. Requires \'knowledge:write\' permission.
         * @summary Get Website Source
         * @param {string} sourceId 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getWebsiteSourceApiV1KnowledgeBaseWebsiteSourceIdGet(sourceId: string, authorization?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<WebsiteSourceDetailDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getWebsiteSourceApiV1KnowledgeBaseWebsiteSourceIdGet(sourceId, authorization, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['KnowledgeBaseApi.getWebsiteSourceApiV1KnowledgeBaseWebsiteSourceIdGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get a website source with its read-only child entries. Requires \'knowledge:write\' permission.
         * @summary Get Website Source
         * @param {string} sourceId 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getWebsiteSourceApiV1KnowledgeBaseWebsiteSourceIdGet_8(sourceId: string, authorization?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<WebsiteSourceDetailDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getWebsiteSourceApiV1KnowledgeBaseWebsiteSourceIdGet_8(sourceId, authorization, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['KnowledgeBaseApi.getWebsiteSourceApiV1KnowledgeBaseWebsiteSourceIdGet_8']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * List all active knowledge base entries in the current user\'s organization. Requires \'knowledge:view\' permission.
         * @summary List Knowledge Entries
         * @param {number} [limit] 
         * @param {number} [offset] 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listKnowledgeEntriesApiV1KnowledgeBaseGet(limit?: number, offset?: number, authorization?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PageKnowledgeBaseResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listKnowledgeEntriesApiV1KnowledgeBaseGet(limit, offset, authorization, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['KnowledgeBaseApi.listKnowledgeEntriesApiV1KnowledgeBaseGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * List all active knowledge base entries in the current user\'s organization. Requires \'knowledge:view\' permission.
         * @summary List Knowledge Entries
         * @param {number} [limit] 
         * @param {number} [offset] 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listKnowledgeEntriesApiV1KnowledgeBaseGet_9(limit?: number, offset?: number, authorization?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PageKnowledgeBaseResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listKnowledgeEntriesApiV1KnowledgeBaseGet_9(limit, offset, authorization, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['KnowledgeBaseApi.listKnowledgeEntriesApiV1KnowledgeBaseGet_9']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * List the organization\'s website sources with sync status and entry counts. Requires \'knowledge:write\' permission.
         * @summary List Website Sources
         * @param {number} [limit] 
         * @param {number} [offset] 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listWebsiteSourcesApiV1KnowledgeBaseWebsiteGet(limit?: number, offset?: number, authorization?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PageWebsiteSourceResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listWebsiteSourcesApiV1KnowledgeBaseWebsiteGet(limit, offset, authorization, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['KnowledgeBaseApi.listWebsiteSourcesApiV1KnowledgeBaseWebsiteGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * List the organization\'s website sources with sync status and entry counts. Requires \'knowledge:write\' permission.
         * @summary List Website Sources
         * @param {number} [limit] 
         * @param {number} [offset] 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listWebsiteSourcesApiV1KnowledgeBaseWebsiteGet_10(limit?: number, offset?: number, authorization?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PageWebsiteSourceResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listWebsiteSourcesApiV1KnowledgeBaseWebsiteGet_10(limit, offset, authorization, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['KnowledgeBaseApi.listWebsiteSourcesApiV1KnowledgeBaseWebsiteGet_10']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Re-crawl a website source. Only allowed when it is idle (READY/FAILED). Requires \'knowledge:write\' permission.
         * @summary Resync Website Source
         * @param {string} sourceId 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async resyncWebsiteSourceApiV1KnowledgeBaseWebsiteSourceIdResyncPost(sourceId: string, authorization?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<WebsiteSourceResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.resyncWebsiteSourceApiV1KnowledgeBaseWebsiteSourceIdResyncPost(sourceId, authorization, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['KnowledgeBaseApi.resyncWebsiteSourceApiV1KnowledgeBaseWebsiteSourceIdResyncPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Re-crawl a website source. Only allowed when it is idle (READY/FAILED). Requires \'knowledge:write\' permission.
         * @summary Resync Website Source
         * @param {string} sourceId 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async resyncWebsiteSourceApiV1KnowledgeBaseWebsiteSourceIdResyncPost_11(sourceId: string, authorization?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<WebsiteSourceResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.resyncWebsiteSourceApiV1KnowledgeBaseWebsiteSourceIdResyncPost_11(sourceId, authorization, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['KnowledgeBaseApi.resyncWebsiteSourceApiV1KnowledgeBaseWebsiteSourceIdResyncPost_11']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Search knowledge base entries by name pattern. Requires \'knowledge:view\' permission.
         * @summary Search By Name
         * @param {string} name 
         * @param {number} [limit] 
         * @param {number} [offset] 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async searchByNameApiV1KnowledgeBaseSearchNameGet(name: string, limit?: number, offset?: number, authorization?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PageKnowledgeBaseResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.searchByNameApiV1KnowledgeBaseSearchNameGet(name, limit, offset, authorization, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['KnowledgeBaseApi.searchByNameApiV1KnowledgeBaseSearchNameGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Search knowledge base entries by name pattern. Requires \'knowledge:view\' permission.
         * @summary Search By Name
         * @param {string} name 
         * @param {number} [limit] 
         * @param {number} [offset] 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async searchByNameApiV1KnowledgeBaseSearchNameGet_12(name: string, limit?: number, offset?: number, authorization?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PageKnowledgeBaseResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.searchByNameApiV1KnowledgeBaseSearchNameGet_12(name, limit, offset, authorization, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['KnowledgeBaseApi.searchByNameApiV1KnowledgeBaseSearchNameGet_12']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Search knowledge base using semantic similarity. Requires \'knowledge:view\' permission.  Returns entries ranked by relevance to the query.
         * @summary Search By Similarity
         * @param {string} query 
         * @param {number} [limit] 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async searchBySimilarityApiV1KnowledgeBaseSearchPost(query: string, limit?: number, authorization?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<KnowledgeBaseSearchResultDTO>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.searchBySimilarityApiV1KnowledgeBaseSearchPost(query, limit, authorization, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['KnowledgeBaseApi.searchBySimilarityApiV1KnowledgeBaseSearchPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Search knowledge base using semantic similarity. Requires \'knowledge:view\' permission.  Returns entries ranked by relevance to the query.
         * @summary Search By Similarity
         * @param {string} query 
         * @param {number} [limit] 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async searchBySimilarityApiV1KnowledgeBaseSearchPost_13(query: string, limit?: number, authorization?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<KnowledgeBaseSearchResultDTO>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.searchBySimilarityApiV1KnowledgeBaseSearchPost_13(query, limit, authorization, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['KnowledgeBaseApi.searchBySimilarityApiV1KnowledgeBaseSearchPost_13']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Update a knowledge base entry. Re-generates embedding if content changed. Requires \'knowledge:write\' permission.
         * @summary Update Knowledge Entry
         * @param {string} entryId 
         * @param {KnowledgeBaseUpdateDTO} knowledgeBaseUpdateDTO 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateKnowledgeEntryApiV1KnowledgeBaseEntryIdPatch(entryId: string, knowledgeBaseUpdateDTO: KnowledgeBaseUpdateDTO, authorization?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<KnowledgeBaseResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateKnowledgeEntryApiV1KnowledgeBaseEntryIdPatch(entryId, knowledgeBaseUpdateDTO, authorization, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['KnowledgeBaseApi.updateKnowledgeEntryApiV1KnowledgeBaseEntryIdPatch']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Update a knowledge base entry. Re-generates embedding if content changed. Requires \'knowledge:write\' permission.
         * @summary Update Knowledge Entry
         * @param {string} entryId 
         * @param {KnowledgeBaseUpdateDTO} knowledgeBaseUpdateDTO 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateKnowledgeEntryApiV1KnowledgeBaseEntryIdPatch_14(entryId: string, knowledgeBaseUpdateDTO: KnowledgeBaseUpdateDTO, authorization?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<KnowledgeBaseResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateKnowledgeEntryApiV1KnowledgeBaseEntryIdPatch_14(entryId, knowledgeBaseUpdateDTO, authorization, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['KnowledgeBaseApi.updateKnowledgeEntryApiV1KnowledgeBaseEntryIdPatch_14']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * KnowledgeBaseApi - factory interface
 * @export
 */
export const KnowledgeBaseApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = KnowledgeBaseApiFp(configuration)
    return {
        /**
         * Analyze a PDF file and return proposed topic-based knowledge-base entries. Requires \'knowledge:write\' permission.  This endpoint: 1. Validates the uploaded file (type and size) 2. Extracts text from the PDF page by page 3. Uses AI to split the document into logical topics, one proposed entry    per topic (a small or single-topic PDF simply yields one entry)  A scanned/image-only PDF with no extractable text is rejected with 400.  Maximum file size: 10MB (configurable via MAX_PDF_SIZE_MB)  Note: This is a utility endpoint and does not modify any database models.
         * @summary Analyze Pdf
         * @param {string} file 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        analyzePdfApiV1KnowledgeBaseAnalyzePdfPost(file: string, authorization?: string, options?: RawAxiosRequestConfig): AxiosPromise<PDFAnalysisResponseDTO> {
            return localVarFp.analyzePdfApiV1KnowledgeBaseAnalyzePdfPost(file, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * Analyze a PDF file and return proposed topic-based knowledge-base entries. Requires \'knowledge:write\' permission.  This endpoint: 1. Validates the uploaded file (type and size) 2. Extracts text from the PDF page by page 3. Uses AI to split the document into logical topics, one proposed entry    per topic (a small or single-topic PDF simply yields one entry)  A scanned/image-only PDF with no extractable text is rejected with 400.  Maximum file size: 10MB (configurable via MAX_PDF_SIZE_MB)  Note: This is a utility endpoint and does not modify any database models.
         * @summary Analyze Pdf
         * @param {string} file 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        analyzePdfApiV1KnowledgeBaseAnalyzePdfPost_1(file: string, authorization?: string, options?: RawAxiosRequestConfig): AxiosPromise<PDFAnalysisResponseDTO> {
            return localVarFp.analyzePdfApiV1KnowledgeBaseAnalyzePdfPost_1(file, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * Create multiple knowledge base entries in one request (all-or-nothing).  Rows and their embeddings are persisted together: any failure rolls the whole batch back, so no partial save is left for the caller to reconcile. Requires \'knowledge:write\' permission.
         * @summary Create Knowledge Entries Bulk
         * @param {KnowledgeBaseBulkCreateDTO} knowledgeBaseBulkCreateDTO 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createKnowledgeEntriesBulkApiV1KnowledgeBaseBulkPost(knowledgeBaseBulkCreateDTO: KnowledgeBaseBulkCreateDTO, authorization?: string, options?: RawAxiosRequestConfig): AxiosPromise<Array<KnowledgeBaseResponseDTO>> {
            return localVarFp.createKnowledgeEntriesBulkApiV1KnowledgeBaseBulkPost(knowledgeBaseBulkCreateDTO, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * Create multiple knowledge base entries in one request (all-or-nothing).  Rows and their embeddings are persisted together: any failure rolls the whole batch back, so no partial save is left for the caller to reconcile. Requires \'knowledge:write\' permission.
         * @summary Create Knowledge Entries Bulk
         * @param {KnowledgeBaseBulkCreateDTO} knowledgeBaseBulkCreateDTO 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createKnowledgeEntriesBulkApiV1KnowledgeBaseBulkPost_2(knowledgeBaseBulkCreateDTO: KnowledgeBaseBulkCreateDTO, authorization?: string, options?: RawAxiosRequestConfig): AxiosPromise<Array<KnowledgeBaseResponseDTO>> {
            return localVarFp.createKnowledgeEntriesBulkApiV1KnowledgeBaseBulkPost_2(knowledgeBaseBulkCreateDTO, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * Create a new knowledge base entry with vector embedding. Requires \'knowledge:write\' permission.
         * @summary Create Knowledge Entry
         * @param {KnowledgeBaseCreateDTO} knowledgeBaseCreateDTO 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createKnowledgeEntryApiV1KnowledgeBasePost(knowledgeBaseCreateDTO: KnowledgeBaseCreateDTO, authorization?: string, options?: RawAxiosRequestConfig): AxiosPromise<KnowledgeBaseResponseDTO> {
            return localVarFp.createKnowledgeEntryApiV1KnowledgeBasePost(knowledgeBaseCreateDTO, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * Create a new knowledge base entry with vector embedding. Requires \'knowledge:write\' permission.
         * @summary Create Knowledge Entry
         * @param {KnowledgeBaseCreateDTO} knowledgeBaseCreateDTO 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createKnowledgeEntryApiV1KnowledgeBasePost_3(knowledgeBaseCreateDTO: KnowledgeBaseCreateDTO, authorization?: string, options?: RawAxiosRequestConfig): AxiosPromise<KnowledgeBaseResponseDTO> {
            return localVarFp.createKnowledgeEntryApiV1KnowledgeBasePost_3(knowledgeBaseCreateDTO, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * Register a website as a knowledge-base source and start its first crawl. Requires \'knowledge:write\' permission.
         * @summary Create Website Source
         * @param {WebsiteSourceCreateDTO} websiteSourceCreateDTO 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createWebsiteSourceApiV1KnowledgeBaseWebsitePost(websiteSourceCreateDTO: WebsiteSourceCreateDTO, authorization?: string, options?: RawAxiosRequestConfig): AxiosPromise<WebsiteSourceResponseDTO> {
            return localVarFp.createWebsiteSourceApiV1KnowledgeBaseWebsitePost(websiteSourceCreateDTO, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * Register a website as a knowledge-base source and start its first crawl. Requires \'knowledge:write\' permission.
         * @summary Create Website Source
         * @param {WebsiteSourceCreateDTO} websiteSourceCreateDTO 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createWebsiteSourceApiV1KnowledgeBaseWebsitePost_4(websiteSourceCreateDTO: WebsiteSourceCreateDTO, authorization?: string, options?: RawAxiosRequestConfig): AxiosPromise<WebsiteSourceResponseDTO> {
            return localVarFp.createWebsiteSourceApiV1KnowledgeBaseWebsitePost_4(websiteSourceCreateDTO, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * Soft delete a knowledge base entry. Requires \'knowledge:write\' permission.
         * @summary Delete Knowledge Entry
         * @param {string} entryId 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteKnowledgeEntryApiV1KnowledgeBaseEntryIdDelete(entryId: string, authorization?: string, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.deleteKnowledgeEntryApiV1KnowledgeBaseEntryIdDelete(entryId, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * Soft delete a knowledge base entry. Requires \'knowledge:write\' permission.
         * @summary Delete Knowledge Entry
         * @param {string} entryId 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteKnowledgeEntryApiV1KnowledgeBaseEntryIdDelete_5(entryId: string, authorization?: string, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.deleteKnowledgeEntryApiV1KnowledgeBaseEntryIdDelete_5(entryId, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * Delete a website source and its generated child entries. Requires \'knowledge:write\' permission.
         * @summary Delete Website Source
         * @param {string} sourceId 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteWebsiteSourceApiV1KnowledgeBaseWebsiteSourceIdDelete(sourceId: string, authorization?: string, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.deleteWebsiteSourceApiV1KnowledgeBaseWebsiteSourceIdDelete(sourceId, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * Delete a website source and its generated child entries. Requires \'knowledge:write\' permission.
         * @summary Delete Website Source
         * @param {string} sourceId 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteWebsiteSourceApiV1KnowledgeBaseWebsiteSourceIdDelete_6(sourceId: string, authorization?: string, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.deleteWebsiteSourceApiV1KnowledgeBaseWebsiteSourceIdDelete_6(sourceId, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * Get a specific knowledge base entry by ID. Requires \'knowledge:view\' permission.
         * @summary Get Knowledge Entry
         * @param {string} entryId 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getKnowledgeEntryApiV1KnowledgeBaseEntryIdGet(entryId: string, authorization?: string, options?: RawAxiosRequestConfig): AxiosPromise<KnowledgeBaseResponseDTO> {
            return localVarFp.getKnowledgeEntryApiV1KnowledgeBaseEntryIdGet(entryId, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * Get a specific knowledge base entry by ID. Requires \'knowledge:view\' permission.
         * @summary Get Knowledge Entry
         * @param {string} entryId 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getKnowledgeEntryApiV1KnowledgeBaseEntryIdGet_7(entryId: string, authorization?: string, options?: RawAxiosRequestConfig): AxiosPromise<KnowledgeBaseResponseDTO> {
            return localVarFp.getKnowledgeEntryApiV1KnowledgeBaseEntryIdGet_7(entryId, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * Get a website source with its read-only child entries. Requires \'knowledge:write\' permission.
         * @summary Get Website Source
         * @param {string} sourceId 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getWebsiteSourceApiV1KnowledgeBaseWebsiteSourceIdGet(sourceId: string, authorization?: string, options?: RawAxiosRequestConfig): AxiosPromise<WebsiteSourceDetailDTO> {
            return localVarFp.getWebsiteSourceApiV1KnowledgeBaseWebsiteSourceIdGet(sourceId, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * Get a website source with its read-only child entries. Requires \'knowledge:write\' permission.
         * @summary Get Website Source
         * @param {string} sourceId 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getWebsiteSourceApiV1KnowledgeBaseWebsiteSourceIdGet_8(sourceId: string, authorization?: string, options?: RawAxiosRequestConfig): AxiosPromise<WebsiteSourceDetailDTO> {
            return localVarFp.getWebsiteSourceApiV1KnowledgeBaseWebsiteSourceIdGet_8(sourceId, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * List all active knowledge base entries in the current user\'s organization. Requires \'knowledge:view\' permission.
         * @summary List Knowledge Entries
         * @param {number} [limit] 
         * @param {number} [offset] 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listKnowledgeEntriesApiV1KnowledgeBaseGet(limit?: number, offset?: number, authorization?: string, options?: RawAxiosRequestConfig): AxiosPromise<PageKnowledgeBaseResponseDTO> {
            return localVarFp.listKnowledgeEntriesApiV1KnowledgeBaseGet(limit, offset, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * List all active knowledge base entries in the current user\'s organization. Requires \'knowledge:view\' permission.
         * @summary List Knowledge Entries
         * @param {number} [limit] 
         * @param {number} [offset] 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listKnowledgeEntriesApiV1KnowledgeBaseGet_9(limit?: number, offset?: number, authorization?: string, options?: RawAxiosRequestConfig): AxiosPromise<PageKnowledgeBaseResponseDTO> {
            return localVarFp.listKnowledgeEntriesApiV1KnowledgeBaseGet_9(limit, offset, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * List the organization\'s website sources with sync status and entry counts. Requires \'knowledge:write\' permission.
         * @summary List Website Sources
         * @param {number} [limit] 
         * @param {number} [offset] 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listWebsiteSourcesApiV1KnowledgeBaseWebsiteGet(limit?: number, offset?: number, authorization?: string, options?: RawAxiosRequestConfig): AxiosPromise<PageWebsiteSourceResponseDTO> {
            return localVarFp.listWebsiteSourcesApiV1KnowledgeBaseWebsiteGet(limit, offset, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * List the organization\'s website sources with sync status and entry counts. Requires \'knowledge:write\' permission.
         * @summary List Website Sources
         * @param {number} [limit] 
         * @param {number} [offset] 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listWebsiteSourcesApiV1KnowledgeBaseWebsiteGet_10(limit?: number, offset?: number, authorization?: string, options?: RawAxiosRequestConfig): AxiosPromise<PageWebsiteSourceResponseDTO> {
            return localVarFp.listWebsiteSourcesApiV1KnowledgeBaseWebsiteGet_10(limit, offset, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * Re-crawl a website source. Only allowed when it is idle (READY/FAILED). Requires \'knowledge:write\' permission.
         * @summary Resync Website Source
         * @param {string} sourceId 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        resyncWebsiteSourceApiV1KnowledgeBaseWebsiteSourceIdResyncPost(sourceId: string, authorization?: string, options?: RawAxiosRequestConfig): AxiosPromise<WebsiteSourceResponseDTO> {
            return localVarFp.resyncWebsiteSourceApiV1KnowledgeBaseWebsiteSourceIdResyncPost(sourceId, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * Re-crawl a website source. Only allowed when it is idle (READY/FAILED). Requires \'knowledge:write\' permission.
         * @summary Resync Website Source
         * @param {string} sourceId 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        resyncWebsiteSourceApiV1KnowledgeBaseWebsiteSourceIdResyncPost_11(sourceId: string, authorization?: string, options?: RawAxiosRequestConfig): AxiosPromise<WebsiteSourceResponseDTO> {
            return localVarFp.resyncWebsiteSourceApiV1KnowledgeBaseWebsiteSourceIdResyncPost_11(sourceId, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * Search knowledge base entries by name pattern. Requires \'knowledge:view\' permission.
         * @summary Search By Name
         * @param {string} name 
         * @param {number} [limit] 
         * @param {number} [offset] 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchByNameApiV1KnowledgeBaseSearchNameGet(name: string, limit?: number, offset?: number, authorization?: string, options?: RawAxiosRequestConfig): AxiosPromise<PageKnowledgeBaseResponseDTO> {
            return localVarFp.searchByNameApiV1KnowledgeBaseSearchNameGet(name, limit, offset, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * Search knowledge base entries by name pattern. Requires \'knowledge:view\' permission.
         * @summary Search By Name
         * @param {string} name 
         * @param {number} [limit] 
         * @param {number} [offset] 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchByNameApiV1KnowledgeBaseSearchNameGet_12(name: string, limit?: number, offset?: number, authorization?: string, options?: RawAxiosRequestConfig): AxiosPromise<PageKnowledgeBaseResponseDTO> {
            return localVarFp.searchByNameApiV1KnowledgeBaseSearchNameGet_12(name, limit, offset, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * Search knowledge base using semantic similarity. Requires \'knowledge:view\' permission.  Returns entries ranked by relevance to the query.
         * @summary Search By Similarity
         * @param {string} query 
         * @param {number} [limit] 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchBySimilarityApiV1KnowledgeBaseSearchPost(query: string, limit?: number, authorization?: string, options?: RawAxiosRequestConfig): AxiosPromise<Array<KnowledgeBaseSearchResultDTO>> {
            return localVarFp.searchBySimilarityApiV1KnowledgeBaseSearchPost(query, limit, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * Search knowledge base using semantic similarity. Requires \'knowledge:view\' permission.  Returns entries ranked by relevance to the query.
         * @summary Search By Similarity
         * @param {string} query 
         * @param {number} [limit] 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchBySimilarityApiV1KnowledgeBaseSearchPost_13(query: string, limit?: number, authorization?: string, options?: RawAxiosRequestConfig): AxiosPromise<Array<KnowledgeBaseSearchResultDTO>> {
            return localVarFp.searchBySimilarityApiV1KnowledgeBaseSearchPost_13(query, limit, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * Update a knowledge base entry. Re-generates embedding if content changed. Requires \'knowledge:write\' permission.
         * @summary Update Knowledge Entry
         * @param {string} entryId 
         * @param {KnowledgeBaseUpdateDTO} knowledgeBaseUpdateDTO 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateKnowledgeEntryApiV1KnowledgeBaseEntryIdPatch(entryId: string, knowledgeBaseUpdateDTO: KnowledgeBaseUpdateDTO, authorization?: string, options?: RawAxiosRequestConfig): AxiosPromise<KnowledgeBaseResponseDTO> {
            return localVarFp.updateKnowledgeEntryApiV1KnowledgeBaseEntryIdPatch(entryId, knowledgeBaseUpdateDTO, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * Update a knowledge base entry. Re-generates embedding if content changed. Requires \'knowledge:write\' permission.
         * @summary Update Knowledge Entry
         * @param {string} entryId 
         * @param {KnowledgeBaseUpdateDTO} knowledgeBaseUpdateDTO 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateKnowledgeEntryApiV1KnowledgeBaseEntryIdPatch_14(entryId: string, knowledgeBaseUpdateDTO: KnowledgeBaseUpdateDTO, authorization?: string, options?: RawAxiosRequestConfig): AxiosPromise<KnowledgeBaseResponseDTO> {
            return localVarFp.updateKnowledgeEntryApiV1KnowledgeBaseEntryIdPatch_14(entryId, knowledgeBaseUpdateDTO, authorization, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * KnowledgeBaseApi - object-oriented interface
 * @export
 * @class KnowledgeBaseApi
 * @extends {BaseAPI}
 */
export class KnowledgeBaseApi extends BaseAPI {
    /**
     * Analyze a PDF file and return proposed topic-based knowledge-base entries. Requires \'knowledge:write\' permission.  This endpoint: 1. Validates the uploaded file (type and size) 2. Extracts text from the PDF page by page 3. Uses AI to split the document into logical topics, one proposed entry    per topic (a small or single-topic PDF simply yields one entry)  A scanned/image-only PDF with no extractable text is rejected with 400.  Maximum file size: 10MB (configurable via MAX_PDF_SIZE_MB)  Note: This is a utility endpoint and does not modify any database models.
     * @summary Analyze Pdf
     * @param {string} file 
     * @param {string} [authorization] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof KnowledgeBaseApi
     */
    public analyzePdfApiV1KnowledgeBaseAnalyzePdfPost(file: string, authorization?: string, options?: RawAxiosRequestConfig) {
        return KnowledgeBaseApiFp(this.configuration).analyzePdfApiV1KnowledgeBaseAnalyzePdfPost(file, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Analyze a PDF file and return proposed topic-based knowledge-base entries. Requires \'knowledge:write\' permission.  This endpoint: 1. Validates the uploaded file (type and size) 2. Extracts text from the PDF page by page 3. Uses AI to split the document into logical topics, one proposed entry    per topic (a small or single-topic PDF simply yields one entry)  A scanned/image-only PDF with no extractable text is rejected with 400.  Maximum file size: 10MB (configurable via MAX_PDF_SIZE_MB)  Note: This is a utility endpoint and does not modify any database models.
     * @summary Analyze Pdf
     * @param {string} file 
     * @param {string} [authorization] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof KnowledgeBaseApi
     */
    public analyzePdfApiV1KnowledgeBaseAnalyzePdfPost_1(file: string, authorization?: string, options?: RawAxiosRequestConfig) {
        return KnowledgeBaseApiFp(this.configuration).analyzePdfApiV1KnowledgeBaseAnalyzePdfPost_1(file, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Create multiple knowledge base entries in one request (all-or-nothing).  Rows and their embeddings are persisted together: any failure rolls the whole batch back, so no partial save is left for the caller to reconcile. Requires \'knowledge:write\' permission.
     * @summary Create Knowledge Entries Bulk
     * @param {KnowledgeBaseBulkCreateDTO} knowledgeBaseBulkCreateDTO 
     * @param {string} [authorization] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof KnowledgeBaseApi
     */
    public createKnowledgeEntriesBulkApiV1KnowledgeBaseBulkPost(knowledgeBaseBulkCreateDTO: KnowledgeBaseBulkCreateDTO, authorization?: string, options?: RawAxiosRequestConfig) {
        return KnowledgeBaseApiFp(this.configuration).createKnowledgeEntriesBulkApiV1KnowledgeBaseBulkPost(knowledgeBaseBulkCreateDTO, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Create multiple knowledge base entries in one request (all-or-nothing).  Rows and their embeddings are persisted together: any failure rolls the whole batch back, so no partial save is left for the caller to reconcile. Requires \'knowledge:write\' permission.
     * @summary Create Knowledge Entries Bulk
     * @param {KnowledgeBaseBulkCreateDTO} knowledgeBaseBulkCreateDTO 
     * @param {string} [authorization] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof KnowledgeBaseApi
     */
    public createKnowledgeEntriesBulkApiV1KnowledgeBaseBulkPost_2(knowledgeBaseBulkCreateDTO: KnowledgeBaseBulkCreateDTO, authorization?: string, options?: RawAxiosRequestConfig) {
        return KnowledgeBaseApiFp(this.configuration).createKnowledgeEntriesBulkApiV1KnowledgeBaseBulkPost_2(knowledgeBaseBulkCreateDTO, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Create a new knowledge base entry with vector embedding. Requires \'knowledge:write\' permission.
     * @summary Create Knowledge Entry
     * @param {KnowledgeBaseCreateDTO} knowledgeBaseCreateDTO 
     * @param {string} [authorization] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof KnowledgeBaseApi
     */
    public createKnowledgeEntryApiV1KnowledgeBasePost(knowledgeBaseCreateDTO: KnowledgeBaseCreateDTO, authorization?: string, options?: RawAxiosRequestConfig) {
        return KnowledgeBaseApiFp(this.configuration).createKnowledgeEntryApiV1KnowledgeBasePost(knowledgeBaseCreateDTO, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Create a new knowledge base entry with vector embedding. Requires \'knowledge:write\' permission.
     * @summary Create Knowledge Entry
     * @param {KnowledgeBaseCreateDTO} knowledgeBaseCreateDTO 
     * @param {string} [authorization] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof KnowledgeBaseApi
     */
    public createKnowledgeEntryApiV1KnowledgeBasePost_3(knowledgeBaseCreateDTO: KnowledgeBaseCreateDTO, authorization?: string, options?: RawAxiosRequestConfig) {
        return KnowledgeBaseApiFp(this.configuration).createKnowledgeEntryApiV1KnowledgeBasePost_3(knowledgeBaseCreateDTO, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Register a website as a knowledge-base source and start its first crawl. Requires \'knowledge:write\' permission.
     * @summary Create Website Source
     * @param {WebsiteSourceCreateDTO} websiteSourceCreateDTO 
     * @param {string} [authorization] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof KnowledgeBaseApi
     */
    public createWebsiteSourceApiV1KnowledgeBaseWebsitePost(websiteSourceCreateDTO: WebsiteSourceCreateDTO, authorization?: string, options?: RawAxiosRequestConfig) {
        return KnowledgeBaseApiFp(this.configuration).createWebsiteSourceApiV1KnowledgeBaseWebsitePost(websiteSourceCreateDTO, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Register a website as a knowledge-base source and start its first crawl. Requires \'knowledge:write\' permission.
     * @summary Create Website Source
     * @param {WebsiteSourceCreateDTO} websiteSourceCreateDTO 
     * @param {string} [authorization] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof KnowledgeBaseApi
     */
    public createWebsiteSourceApiV1KnowledgeBaseWebsitePost_4(websiteSourceCreateDTO: WebsiteSourceCreateDTO, authorization?: string, options?: RawAxiosRequestConfig) {
        return KnowledgeBaseApiFp(this.configuration).createWebsiteSourceApiV1KnowledgeBaseWebsitePost_4(websiteSourceCreateDTO, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Soft delete a knowledge base entry. Requires \'knowledge:write\' permission.
     * @summary Delete Knowledge Entry
     * @param {string} entryId 
     * @param {string} [authorization] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof KnowledgeBaseApi
     */
    public deleteKnowledgeEntryApiV1KnowledgeBaseEntryIdDelete(entryId: string, authorization?: string, options?: RawAxiosRequestConfig) {
        return KnowledgeBaseApiFp(this.configuration).deleteKnowledgeEntryApiV1KnowledgeBaseEntryIdDelete(entryId, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Soft delete a knowledge base entry. Requires \'knowledge:write\' permission.
     * @summary Delete Knowledge Entry
     * @param {string} entryId 
     * @param {string} [authorization] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof KnowledgeBaseApi
     */
    public deleteKnowledgeEntryApiV1KnowledgeBaseEntryIdDelete_5(entryId: string, authorization?: string, options?: RawAxiosRequestConfig) {
        return KnowledgeBaseApiFp(this.configuration).deleteKnowledgeEntryApiV1KnowledgeBaseEntryIdDelete_5(entryId, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Delete a website source and its generated child entries. Requires \'knowledge:write\' permission.
     * @summary Delete Website Source
     * @param {string} sourceId 
     * @param {string} [authorization] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof KnowledgeBaseApi
     */
    public deleteWebsiteSourceApiV1KnowledgeBaseWebsiteSourceIdDelete(sourceId: string, authorization?: string, options?: RawAxiosRequestConfig) {
        return KnowledgeBaseApiFp(this.configuration).deleteWebsiteSourceApiV1KnowledgeBaseWebsiteSourceIdDelete(sourceId, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Delete a website source and its generated child entries. Requires \'knowledge:write\' permission.
     * @summary Delete Website Source
     * @param {string} sourceId 
     * @param {string} [authorization] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof KnowledgeBaseApi
     */
    public deleteWebsiteSourceApiV1KnowledgeBaseWebsiteSourceIdDelete_6(sourceId: string, authorization?: string, options?: RawAxiosRequestConfig) {
        return KnowledgeBaseApiFp(this.configuration).deleteWebsiteSourceApiV1KnowledgeBaseWebsiteSourceIdDelete_6(sourceId, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get a specific knowledge base entry by ID. Requires \'knowledge:view\' permission.
     * @summary Get Knowledge Entry
     * @param {string} entryId 
     * @param {string} [authorization] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof KnowledgeBaseApi
     */
    public getKnowledgeEntryApiV1KnowledgeBaseEntryIdGet(entryId: string, authorization?: string, options?: RawAxiosRequestConfig) {
        return KnowledgeBaseApiFp(this.configuration).getKnowledgeEntryApiV1KnowledgeBaseEntryIdGet(entryId, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get a specific knowledge base entry by ID. Requires \'knowledge:view\' permission.
     * @summary Get Knowledge Entry
     * @param {string} entryId 
     * @param {string} [authorization] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof KnowledgeBaseApi
     */
    public getKnowledgeEntryApiV1KnowledgeBaseEntryIdGet_7(entryId: string, authorization?: string, options?: RawAxiosRequestConfig) {
        return KnowledgeBaseApiFp(this.configuration).getKnowledgeEntryApiV1KnowledgeBaseEntryIdGet_7(entryId, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get a website source with its read-only child entries. Requires \'knowledge:write\' permission.
     * @summary Get Website Source
     * @param {string} sourceId 
     * @param {string} [authorization] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof KnowledgeBaseApi
     */
    public getWebsiteSourceApiV1KnowledgeBaseWebsiteSourceIdGet(sourceId: string, authorization?: string, options?: RawAxiosRequestConfig) {
        return KnowledgeBaseApiFp(this.configuration).getWebsiteSourceApiV1KnowledgeBaseWebsiteSourceIdGet(sourceId, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get a website source with its read-only child entries. Requires \'knowledge:write\' permission.
     * @summary Get Website Source
     * @param {string} sourceId 
     * @param {string} [authorization] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof KnowledgeBaseApi
     */
    public getWebsiteSourceApiV1KnowledgeBaseWebsiteSourceIdGet_8(sourceId: string, authorization?: string, options?: RawAxiosRequestConfig) {
        return KnowledgeBaseApiFp(this.configuration).getWebsiteSourceApiV1KnowledgeBaseWebsiteSourceIdGet_8(sourceId, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * List all active knowledge base entries in the current user\'s organization. Requires \'knowledge:view\' permission.
     * @summary List Knowledge Entries
     * @param {number} [limit] 
     * @param {number} [offset] 
     * @param {string} [authorization] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof KnowledgeBaseApi
     */
    public listKnowledgeEntriesApiV1KnowledgeBaseGet(limit?: number, offset?: number, authorization?: string, options?: RawAxiosRequestConfig) {
        return KnowledgeBaseApiFp(this.configuration).listKnowledgeEntriesApiV1KnowledgeBaseGet(limit, offset, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * List all active knowledge base entries in the current user\'s organization. Requires \'knowledge:view\' permission.
     * @summary List Knowledge Entries
     * @param {number} [limit] 
     * @param {number} [offset] 
     * @param {string} [authorization] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof KnowledgeBaseApi
     */
    public listKnowledgeEntriesApiV1KnowledgeBaseGet_9(limit?: number, offset?: number, authorization?: string, options?: RawAxiosRequestConfig) {
        return KnowledgeBaseApiFp(this.configuration).listKnowledgeEntriesApiV1KnowledgeBaseGet_9(limit, offset, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * List the organization\'s website sources with sync status and entry counts. Requires \'knowledge:write\' permission.
     * @summary List Website Sources
     * @param {number} [limit] 
     * @param {number} [offset] 
     * @param {string} [authorization] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof KnowledgeBaseApi
     */
    public listWebsiteSourcesApiV1KnowledgeBaseWebsiteGet(limit?: number, offset?: number, authorization?: string, options?: RawAxiosRequestConfig) {
        return KnowledgeBaseApiFp(this.configuration).listWebsiteSourcesApiV1KnowledgeBaseWebsiteGet(limit, offset, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * List the organization\'s website sources with sync status and entry counts. Requires \'knowledge:write\' permission.
     * @summary List Website Sources
     * @param {number} [limit] 
     * @param {number} [offset] 
     * @param {string} [authorization] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof KnowledgeBaseApi
     */
    public listWebsiteSourcesApiV1KnowledgeBaseWebsiteGet_10(limit?: number, offset?: number, authorization?: string, options?: RawAxiosRequestConfig) {
        return KnowledgeBaseApiFp(this.configuration).listWebsiteSourcesApiV1KnowledgeBaseWebsiteGet_10(limit, offset, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Re-crawl a website source. Only allowed when it is idle (READY/FAILED). Requires \'knowledge:write\' permission.
     * @summary Resync Website Source
     * @param {string} sourceId 
     * @param {string} [authorization] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof KnowledgeBaseApi
     */
    public resyncWebsiteSourceApiV1KnowledgeBaseWebsiteSourceIdResyncPost(sourceId: string, authorization?: string, options?: RawAxiosRequestConfig) {
        return KnowledgeBaseApiFp(this.configuration).resyncWebsiteSourceApiV1KnowledgeBaseWebsiteSourceIdResyncPost(sourceId, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Re-crawl a website source. Only allowed when it is idle (READY/FAILED). Requires \'knowledge:write\' permission.
     * @summary Resync Website Source
     * @param {string} sourceId 
     * @param {string} [authorization] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof KnowledgeBaseApi
     */
    public resyncWebsiteSourceApiV1KnowledgeBaseWebsiteSourceIdResyncPost_11(sourceId: string, authorization?: string, options?: RawAxiosRequestConfig) {
        return KnowledgeBaseApiFp(this.configuration).resyncWebsiteSourceApiV1KnowledgeBaseWebsiteSourceIdResyncPost_11(sourceId, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Search knowledge base entries by name pattern. Requires \'knowledge:view\' permission.
     * @summary Search By Name
     * @param {string} name 
     * @param {number} [limit] 
     * @param {number} [offset] 
     * @param {string} [authorization] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof KnowledgeBaseApi
     */
    public searchByNameApiV1KnowledgeBaseSearchNameGet(name: string, limit?: number, offset?: number, authorization?: string, options?: RawAxiosRequestConfig) {
        return KnowledgeBaseApiFp(this.configuration).searchByNameApiV1KnowledgeBaseSearchNameGet(name, limit, offset, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Search knowledge base entries by name pattern. Requires \'knowledge:view\' permission.
     * @summary Search By Name
     * @param {string} name 
     * @param {number} [limit] 
     * @param {number} [offset] 
     * @param {string} [authorization] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof KnowledgeBaseApi
     */
    public searchByNameApiV1KnowledgeBaseSearchNameGet_12(name: string, limit?: number, offset?: number, authorization?: string, options?: RawAxiosRequestConfig) {
        return KnowledgeBaseApiFp(this.configuration).searchByNameApiV1KnowledgeBaseSearchNameGet_12(name, limit, offset, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Search knowledge base using semantic similarity. Requires \'knowledge:view\' permission.  Returns entries ranked by relevance to the query.
     * @summary Search By Similarity
     * @param {string} query 
     * @param {number} [limit] 
     * @param {string} [authorization] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof KnowledgeBaseApi
     */
    public searchBySimilarityApiV1KnowledgeBaseSearchPost(query: string, limit?: number, authorization?: string, options?: RawAxiosRequestConfig) {
        return KnowledgeBaseApiFp(this.configuration).searchBySimilarityApiV1KnowledgeBaseSearchPost(query, limit, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Search knowledge base using semantic similarity. Requires \'knowledge:view\' permission.  Returns entries ranked by relevance to the query.
     * @summary Search By Similarity
     * @param {string} query 
     * @param {number} [limit] 
     * @param {string} [authorization] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof KnowledgeBaseApi
     */
    public searchBySimilarityApiV1KnowledgeBaseSearchPost_13(query: string, limit?: number, authorization?: string, options?: RawAxiosRequestConfig) {
        return KnowledgeBaseApiFp(this.configuration).searchBySimilarityApiV1KnowledgeBaseSearchPost_13(query, limit, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Update a knowledge base entry. Re-generates embedding if content changed. Requires \'knowledge:write\' permission.
     * @summary Update Knowledge Entry
     * @param {string} entryId 
     * @param {KnowledgeBaseUpdateDTO} knowledgeBaseUpdateDTO 
     * @param {string} [authorization] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof KnowledgeBaseApi
     */
    public updateKnowledgeEntryApiV1KnowledgeBaseEntryIdPatch(entryId: string, knowledgeBaseUpdateDTO: KnowledgeBaseUpdateDTO, authorization?: string, options?: RawAxiosRequestConfig) {
        return KnowledgeBaseApiFp(this.configuration).updateKnowledgeEntryApiV1KnowledgeBaseEntryIdPatch(entryId, knowledgeBaseUpdateDTO, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Update a knowledge base entry. Re-generates embedding if content changed. Requires \'knowledge:write\' permission.
     * @summary Update Knowledge Entry
     * @param {string} entryId 
     * @param {KnowledgeBaseUpdateDTO} knowledgeBaseUpdateDTO 
     * @param {string} [authorization] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof KnowledgeBaseApi
     */
    public updateKnowledgeEntryApiV1KnowledgeBaseEntryIdPatch_14(entryId: string, knowledgeBaseUpdateDTO: KnowledgeBaseUpdateDTO, authorization?: string, options?: RawAxiosRequestConfig) {
        return KnowledgeBaseApiFp(this.configuration).updateKnowledgeEntryApiV1KnowledgeBaseEntryIdPatch_14(entryId, knowledgeBaseUpdateDTO, authorization, options).then((request) => request(this.axios, this.basePath));
    }
}

